export default "__VITE_ASSET__ba0b3374__"